import { createMuiTheme } from "@material-ui/core";
import logo from "../resources/svg/M-large.svg";

const {
  breakpoints,
  spacing,
  zIndex,
  palette
} = createMuiTheme();

export default createMuiTheme({
  palette: {
    type: "light",
    primary: {
      main: "#FF4336",
    },
    secondary: {
      main: "#000"
    },
    background: {
      paper: "#FFF",
      default: "#EEE"
    },
    text: {
      primary: "#121212"
    }
  },

  typography: {
    fontFamily: "'Source Code Pro', monospace",
    h1: {
      fontSize: 24
    },
    h2: {
      fontSize: 18,
      fontWeight: 700
    },
    h3: {
      fontSize: 18,
      fontWeight: 500
    },
    h4: {
      fontSize: 18
    },
    h5: {
      fontSize: 16
    },
    body1: {
      fontSize: 14
    },
    body2: {
      fontSize: 12
    }
  },

  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          backgroundImage: `url(${logo})`,
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          backgroundPosition: "50% 50%"
        },
        "::-webkit-scrollbar-track": {
          backgroundColor: palette.grey[300]
        },
        "::-webkit-scrollbar": {
          height: 10,
          width: 10
        },
        "::-webkit-scrollbar-thumb": {
          backgroundColor: palette.text.primary,
          border: "none"
        }
      }
    },
    MuiAppBar: {
      root: {
        zIndex: zIndex.drawer + 1
      }
    },
    MuiToolbar: {
      root: {
        justifyContent: "space-between"
      }
    },
    MuiCard: {
      root: {
        position: "relative",
        minHeight: 200
      }
    },
    MuiCardHeader: {
      root: {
        zIndex: 1,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        padding: 8
      },
      avatar: {
        marginRight: 0
      }
    },
    MuiCardContent: {
      root: {
        textAlign: "center"
      }
    },
    MuiCardActionArea: {
      root: {
        height: "100%"
      }
    },
    MuiDialogTitle: {
      root: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid #121212",
        fontSize: 18,
        fontWeight: 700
      }
    },
    MuiDialogContent: {
      root: {
        minWidth: 480,
        padding: 40,
      }
    },
    MuiDialogActions: {
      root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    },
    MuiDrawer: {
      root: {
        flexShrink: 0
      },
      paperAnchorDockedLeft: {
        borderRight: 0
      },
      paper: {
        width: 320,
      },
    },
    MuiTabs: {
      root: {
        minHeight: 35
      },
      flexContainer: {
        height: 35,
        borderBottom: "2px solid rgba(0,0,0,0)"
      },
      indicator: {
        height: 2,
        marginLeft: 12,
        maxWidth: 24
      }
    },
    MuiTab: {
      textColorInherit: {
        opacity: 1
      },
      root: {
        "&::after": {
          display: "block",
          content: "'//'",
          position: "absolute",
          right: -(spacing(3)),
          color: "#121212"
        },
        "&:last-child": {
          "&::after": {
            display: "none"
          }
        },
        overflow: "visible",
        minHeight: 0,
        textTransform: "initial",
        margin: spacing(0, 2),
        minWidth: 0,
        [breakpoints.up("md")]: {
          minWidth: 0,
        },
        "&$selected": {
          fontWeight: 700,
          "&::after": {
            fontWeight: "initial",
          },
        }
      },
      selected: { },
    },
    MuiListItem: {
      root: {
        "&$selected": {
          backgroundColor: "#EEE",
        }
      },
      selected: {},
    },
    MuiButton: {
      root: {
        minWidth: 150
      },
      outlined: {
        border: "1px solid #121212",
        borderRadius: 20,
        margin: "0px 20px 0px 20px"
      },
      label: {
        fontWeight: 400
      },
      textPrimary: {
        textTransform: "none"
      },
      textSecondary: {
        textTransform: "none"
      },
    },
    MuiFab: {
      root: {
        backgroundColor: "transparent",
        zIndex: zIndex.drawer + 1,
        boxShadow: "none"
      },
      primary: {
        color: "#FF4336",
        backgroundColor: "transparent",
        border: "1px solid #FF4336",
        "&:hover": {
          backgroundColor: "rgba(178, 46, 37, 0.2)"
        }
      }
    },
    MuiInputLabel: {
      filled: {
        "&.MuiInputLabel-shrink": {
          transform: "translate(0px, -16px) scale(0.75)"
        }
      }
    },
    MuiFilledInput: {
      input: {
        padding: spacing(2)
      }
    }
  },
  shape: {
    borderRadius: 0
  },
  props: {
    MuiIconButton: {
      color: "secondary"
    },
    MuiButton: {
      variant: "outlined",
      color: "primary",
    },
    MuiAppBar: {
      color: "inherit",
      variant: "outlined",
      position: "fixed"
    },
    MuiBreadcrumbs: {
      separator: "//"
    },
    MuiDrawer: {
      open: true,
      variant: "permanent"
    },
    MuiTabs: {
      indicatorColor: "primary",
    },
    MuiTab: {
    },
    MuiTypography: {
      color: "textPrimary"
    },
    MuiCard: {
      elevation: 0
    },
    MuiPaper: {
      elevation: 0
    },
    MuiFab: {
      size: "large",
      color: "primary"
    }
  }
});
